// Test IDs for the Pacientes (Patient records) feature.

export const PATIENTS = {
  page: 'patients-page',
  searchInput: 'patients-search-input',
  tagFilterSelect: 'patients-tag-filter-select',
  addButton: 'patients-add-button',
  emptyState: 'patients-empty-state',
  table: 'patients-table',
  rowPrefix: 'patients-row-', // + patientId
  tagBadgePrefix: 'patients-tag-badge-',
  deleteButtonPrefix: 'patients-delete-button-', // + patientId
  deleteConfirmButton: 'patients-delete-confirm-button',
  deleteCancelButton: 'patients-delete-cancel-button',

  quickAddModal: 'patients-quick-add-modal',
  quickAddNameInput: 'patients-quick-add-name-input',
  quickAddPhoneInput: 'patients-quick-add-phone-input',
  quickAddEmailInput: 'patients-quick-add-email-input',
  quickAddDobInput: 'patients-quick-add-dob-input',
  quickAddEmergencyNameInput: 'patients-quick-add-emergency-name-input',
  quickAddEmergencyPhoneInput: 'patients-quick-add-emergency-phone-input',
  quickAddAllergiesInput: 'patients-quick-add-allergies-input',
  quickAddSaveButton: 'patients-quick-add-save-button',
  quickAddCancelButton: 'patients-quick-add-cancel-button',
  quickAddErrorMessage: 'patients-quick-add-error-message',

  profilePage: 'patient-profile-page',
  profileBackButton: 'patient-profile-back-button',
  profileName: 'patient-profile-name',
  profileMissingFieldsBanner: 'patient-profile-missing-fields-banner',
  profilePhotoUpload: 'patient-profile-photo-upload',
  tabInfo: 'patient-tab-info',
  tabTreatments: 'patient-tab-treatments',
  tabPhotos: 'patient-tab-photos',
  tabAppointments: 'patient-tab-appointments',
  tabPayments: 'patient-tab-payments',

  infoNameInput: 'patient-info-name-input',
  infoPhoneInput: 'patient-info-phone-input',
  infoEmailInput: 'patient-info-email-input',
  infoDobInput: 'patient-info-dob-input',
  infoEmergencyNameInput: 'patient-info-emergency-name-input',
  infoEmergencyPhoneInput: 'patient-info-emergency-phone-input',
  infoAllergiesInput: 'patient-info-allergies-input',
  infoMedicalNotesInput: 'patient-info-medical-notes-input',
  infoInternalNotesInput: 'patient-info-internal-notes-input',
  infoSaveButton: 'patient-info-save-button',
  infoContactReadonlyNotice: 'patient-info-readonly-notice',

  tagOptionPrefix: 'patient-tag-option-', // + tagValue
  tagRemovePrefix: 'patient-tag-remove-', // + tagValue
  tagCustomInput: 'patient-tag-custom-input',
  tagCustomAddButton: 'patient-tag-custom-add-button',

  treatmentAddButton: 'patient-treatment-add-button',
  treatmentEmptyState: 'patient-treatment-empty-state',
  treatmentItemPrefix: 'patient-treatment-item-',
  treatmentModal: 'patient-treatment-modal',
  treatmentModalServiceSelect: 'patient-treatment-modal-service-select',
  treatmentModalProfessionalSelect: 'patient-treatment-modal-professional-select',
  treatmentModalDateInput: 'patient-treatment-modal-date-input',
  treatmentModalDoseInput: 'patient-treatment-modal-dose-input',
  treatmentModalAreaInput: 'patient-treatment-modal-area-input',
  treatmentModalObservationsInput: 'patient-treatment-modal-observations-input',
  treatmentModalProductInput: 'patient-treatment-modal-product-input',
  treatmentModalSaveButton: 'patient-treatment-modal-save-button',
  treatmentModalCancelButton: 'patient-treatment-modal-cancel-button',

  photoUploadInput: 'patient-photo-upload-input',
  photoTypeSelect: 'patient-photo-type-select',
  photoCaptionInput: 'patient-photo-caption-input',
  photoSaveButton: 'patient-photo-save-button',
  photoGrid: 'patient-photo-grid',
  photoItemPrefix: 'patient-photo-item-',
  photoDeleteButtonPrefix: 'patient-photo-delete-button-',
  photoEmptyState: 'patient-photo-empty-state',

  consentAddButton: 'patient-consent-add-button',
  consentEmptyState: 'patient-consent-empty-state',
  consentItemPrefix: 'patient-consent-item-',
  consentModal: 'patient-consent-modal',
  consentModalTitleInput: 'patient-consent-modal-title-input',
  consentModalTextInput: 'patient-consent-modal-text-input',
  consentModalSignatureCanvas: 'patient-consent-modal-signature-canvas',
  consentModalSignatureClear: 'patient-consent-modal-signature-clear',
  consentModalSignedNameInput: 'patient-consent-modal-signed-name-input',
  consentModalSaveButton: 'patient-consent-modal-save-button',
  consentModalCancelButton: 'patient-consent-modal-cancel-button',

  appointmentsList: 'patient-appointments-list',
  appointmentItemPrefix: 'patient-appointment-item-',
  appointmentOriginPrefix: 'patient-appointment-origin-',
  appointmentsEmptyState: 'patient-appointments-empty-state',

  paymentAddButton: 'patient-payment-add-button',
  paymentsList: 'patient-payments-list',
  paymentItemPrefix: 'patient-payment-item-',
  paymentsEmptyState: 'patient-payments-empty-state',
  paymentsRestrictedNotice: 'patient-payments-restricted-notice',
  paymentModal: 'patient-payment-modal',
  paymentModalAmountInput: 'patient-payment-modal-amount-input',
  paymentModalMethodSelect: 'patient-payment-modal-method-select',
  paymentModalDateInput: 'patient-payment-modal-date-input',
  paymentModalNotesInput: 'patient-payment-modal-notes-input',
  paymentModalSaveButton: 'patient-payment-modal-save-button',
  paymentModalCancelButton: 'patient-payment-modal-cancel-button',

  agendaViewProfileButton: 'agenda-view-patient-profile-button',
  agendaRegisterTreatmentButton: 'agenda-register-treatment-button',
};
